<template>
    <div class="satisfactionSearch">
        <Row :gutter="4">
            <Col span="4">
                <Input search v-model="subjectSearchKey" :placeholder="$t('satisfaction.searchBySubject')" />
            </Col>
            <Col span="4">
                <Select v-model="priorityId" filterable :placeholder="$t('satisfaction.searchByPriority')" :transfer="true">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in priorityIdList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <DatePicker type="date" :placeholder="$t('satisfaction.pleaseSelectStartTime')" v-model="startTime" style="width:100%;"></DatePicker>
            </Col>
            <Col span="4">
                <DatePicker type="date" :placeholder="$t('satisfaction.pleaseSelectEndTime')" v-model="endTime" style="width:100%;"></DatePicker>
            </Col>
            <Col span="4">
                <Select v-model="satisfaction" filterable :placeholder="$t('satisfaction.satisfaction')" :transfer="true">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.name" v-for="item in levelList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Button type="info" @click="show" v-hasPermission="['cases:satisfaction:search']">{{ $t('alarms.common.search') }}</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableSatisfaction from '../satisfaction/TableSatisfaction'
    var tableSatisfaction = TableSatisfaction;
    export default {
        name: 'SatisfactionSearch',
        data () {
            return {
                subjectSearchKey:'',
                priorityId:'',
                startTime:'',
                endTime:'',
                satisfaction:'',
                priorityIdList:[{
                    id:0,
                    name:'P1'
                },{
                    id:1,
                    name:'P2'
                },{
                    id:2,
                    name:'P3'
                },{
                    id:3,
                    name:'P4'
                },{
                    id:4,
                    name:'P5'
                }],
                levelList:[{
                    id:0,
                    name:0.5
                },{
                    id:1,
                    name:1
                },{
                    id:2,
                    name:1.5
                },{
                    id:3,
                    name:2
                },{
                    id:4,
                    name:2.5
                },{
                    id:5,
                    name:3
                },{
                    id:6,
                    name:3.5
                },{
                    id:7,
                    name:4
                },{
                    id:8,
                    name:4.5
                },{
                    id:9,
                    name:5
                }]
            }
        },
        methods: {
            show: function () {
                tableSatisfaction.methods.showAll(this.subjectSearchKey,this.priorityId,this.startTime,
                    this.endTime,this.satisfaction);
            }
        }
    }
</script>
<style scoped>
    .satisfactionSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/satisfaction/SatisfactionSearch.vue